// src/pages/tutor/TutorDashboard.js
import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

import StudentTopBar from "../../components/Student/StudentTopBar";
import UpdatesCard from "../../components/Tutor/UpdatesCard";

import { logout } from "../../utils/authUtils";
import { getTutorDashboardUpdates } from "../../utils/tutor/getTutorDashboardUpdates";

const TutorDashboard = () => {
  const { user } = useAuth();
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      try {
        if (!user?.uid) return;
        const data = await getTutorDashboardUpdates({ tutorUid: user?.uid });
        if (isMounted) {
          setUpdates(data);
        }
      } catch (err) {
        console.error("Failed to load tutor dashboard", err);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, [user?.uid]);

  return (
    <Box>
      <StudentTopBar
        name="Cory"
        onLogout={handleLogout}
      />

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <CircularProgress />
        </Box>
      ) : (
        <UpdatesCard updates={updates} />
      )}
    </Box>
  );
};

export default TutorDashboard;
